import React from 'react'
import { CommentsContainer } from './CommentsContainer'
import { DescriptionComments } from './DescriptionComments'
import { SelectCommentsContainer } from './SelectCommentsContainer'
import { TextAreaComments } from './TextAreaComments'


export const CommentItem = (
    {
        name,
        reasons,
        comments,
        isPutComment,
        checkedValue,
        actionDelete,
        actionSaveEdit,
        onChangue,
        disabled
    }
) => {
    return (
        <CommentsContainer
            actionSaveEdit={actionSaveEdit}
            actionDelete={actionDelete}
            isPutComment={isPutComment}

        >
            <div className='py-2 flex flex-col gap-1 px-2'>
                <DescriptionComments
                    title={reasons.title}
                    description={reasons.description}
                    disabled={disabled}
                />
                <SelectCommentsContainer
                    checkedValue={checkedValue}
                    disabled={disabled}
                    isRequired={reasons.isRequired}
                    nameInput={[name, "reason"]}
                    onChangue={onChangue}
                    options={reasons.items}
                    placeholder={reasons.placeholder}
                />
            </div>
            <div className='py-2 flex flex-col gap-1 px-2'>
                <DescriptionComments
                    title={comments.title}
                    description={comments.description}
                    disabled={disabled}
                />
                <TextAreaComments
                    nameInput={[name, "comment"]}
                    isRequired={comments.isRequired}
                    disabled={disabled}
                    placeholder={comments.placeholder}
                />
            </div>
        </CommentsContainer>
    )
}
